import strings from 'strings';

import { ORIGIN_TABLE_MAP } from './common';

export const CALL_TYPES = {
  closing: 'closing',
  debrief: 'debrief',
  preparation: 'preparation'
};

export const TASK_STATUS = {
  completed: { id: 1, title: strings.dailyPlan.taskStatus.completed },
  pending: { id: 2, title: strings.dailyPlan.taskStatus.pending },
  overdue: { id: 3, title: strings.dailyPlan.taskStatus.overdue }
};

export const TASK_TYPES = {
  recruitJobOrder: 1,
  marketCandidate: 2,
  debriefCall: 3,
  preparationCall: 4,
  closingCall: 5,
  other: 6
};

export const OTHER_OUTCOME_TASK = {
  id: 9,
  title: strings.dailyPlan.outcomes.otherOutcome
};

export const ALLOWED_TASKS_BY_SINGLE_ENTITY_ORIGIN_TABLE = {
  [ORIGIN_TABLE_MAP.Candidates]: [TASK_TYPES.recruitJobOrder, TASK_TYPES.other],
  [ORIGIN_TABLE_MAP.Companies]: [TASK_TYPES.marketCandidate, TASK_TYPES.other]
};
